<template>
  <div>
    <excise-transactions listObject="cask" :objectId="caskId"
                          :activityTypes="[{text:'All',value:''},
                                            {text:'Opening inventory',value:'ExciseVesselTransactionInitial'},
                                            {text:'Transfer site',value:'ExciseVesselTransactionTransferSite'},
                                            {text:'Filled',value:'TankTransactionFillCask'},
                                            {text:'Reduce inventory',value:'ExciseVesselTransactionReduceInventory'},
                                            {text:'Empty casks(s)',value:'CasksEmpty'}
                                          ]"
                          :back="[{text:'Casks',to:{name:'InventoryCasks'}}]"
                          :vessel="false"/>
  </div>
</template>

<script>
import ExciseTransactions from '@/components/ExciseTransactions'

export default {
  name: 'InventoryCasksTransactions',
  components: {ExciseTransactions},
  props: {
    caskId: {type:String, required:true}
  }
}
</script>